import * as types from '../../action-types';
import {updateConsumer as initialState } from "../../initialState";

const updateConsumer = (state=initialState, action) => {
  switch (action.type) {
    case types.UPDATE_CONSUMER_START:
      return {
        ...state,
        isLoading: true
      };
    case types.UPDATE_CONSUMER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.UPDATE_CONSUMER_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.UPDATE_CONSUMER_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default updateConsumer;
